Whether the candidate must not be contacted by hirers.

- For uploaded candidates from the Proactive Sourcing use case,
  this field may be set to prevent hirers from contacting them through SEEK Talent Search.
  A `null` value is treated the same as an explicit `false`.

- For `PositionOpening` contact people from the Job Posting and Proactive Sourcing use cases,
  this field is always ignored.
